import React from "react";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  BRAND_ASSETS,
  BRAND_COLORS,
  BRAND_FONT_FAMILY,
} from "../utils/brandAssets";

const LOCKUP = {
  gap: 2,
  py: 2,
  iconHeight: {
    default: 32,
    compact: 24,
  },
};

const Logo = ({ sx = {}, iconOnly = false, compact = false }) => {
  const navigate = useNavigate();
  const {
    height = compact ? LOCKUP.iconHeight.compact : LOCKUP.iconHeight.default,
    width,
    ...containerSx
  } = sx;

  const handleClick = () => {
    navigate("/");
  };

  return (
    <Box
      onClick={handleClick}
      role="link"
      aria-label="Stats.fan home"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: LOCKUP.gap,
        py: LOCKUP.py,
        cursor: "pointer",
        width,
        flexShrink: 0,
        transition: "opacity 0.2s ease",
        "&:hover": {
          opacity: 0.8,
        },
        ...containerSx,
      }}
    >
      <Box
        component="img"
        src={BRAND_ASSETS.icon}
        alt=""
        sx={{
          height,
          width: "auto",
          display: "block",
          flexShrink: 0,
        }}
      />
      {!iconOnly && (
        <Typography
          component="span"
          sx={{
            fontFamily: BRAND_FONT_FAMILY,
            fontWeight: 400,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            fontSize: compact
              ? "1rem"
              : { xs: "1.15rem", md: "1.25rem" },
            lineHeight: 1,
            color: BRAND_COLORS.cyan,
            whiteSpace: "nowrap",
            flexShrink: 0,
          }}
        >
          STATS.FAN
        </Typography>
      )}
    </Box>
  );
};

export default Logo;
